import { ProductImportStatus } from '../../common/product-import-status';
import { IDoorSizeOption, DoorSizeOption } from '../../common/door-size-option';
import { IStormDoorHandleTypeOption, StormDoorHandleTypeOption } from '../../common/storm-door-handle-type-option';
import { IStormDoorColorOption, StormDoorColorOption } from '../../common/storm-door-color-option';
import { ILowesProductTexture, LowesProductTexture } from '../../common/lowes/lowes-product-texture';

export interface ILowesStormDoorEditingModel {
    id: string;
    vendorUrl: string;
    importStatus: ProductImportStatus;
    description: string;
    imageUrls: string[];
    sellingPoints: string[];
    doorSizes: IDoorSizeOption[];
    doorHandleTypes: IStormDoorHandleTypeOption[];
    colorFamilies: IStormDoorColorOption[];
    colorVariants: ILowesProductTexture[];
    productReviewSummary: string;
}


export class LowesStormDoorEditingModel implements ILowesStormDoorEditingModel {
    public id: string = '';
    public vendorUrl: string = '';
    public importStatus: ProductImportStatus = ProductImportStatus.Indeterminate;
    public description: string = '';
    public imageUrls: string[] = [];
    public sellingPoints: string[] = [];
    public doorSizes: IDoorSizeOption[] = [];
    public doorHandleTypes: IStormDoorHandleTypeOption[] = [];
    public colorFamilies: IStormDoorColorOption[] = [];
    public colorVariants: ILowesProductTexture[] = [];
    public productReviewSummary: string = '';
}


